import React from 'react';
import { t } from 'i18next';
import DividerWithText from '../../../components/DividerWithText';
import UserAccessLogs from './SubComponents/UserAccessLogs';
import ActiveContracts from './SubComponents/ActiveContracts';
import UserInvitations from './SubComponents/UserInvitations';
import IncomingEvents from './SubComponents/IncomingEvents';
import IncomingOrders from './SubComponents/IncomingOrders';
import CustomTablePagination from './SubComponents/CustomTablePagination';
import GuardApp from './Functionality/GuardApp';

const Guard = () => {

    const { guardSizes, setSizeChanged, setFirstLoad, setGuardSizes, guardLists,
        userDataTransformVisitor, userDataTransformHost, userDataTransformValidatedBy, userDataTransformContractor,
        userDataTransformSupplierEmployee, userDataTransformSupplierVehicle } = GuardApp();

    return (
        <div className="row d-flex flex-nowrap overflow-y-auto overflow-x-hidden">
            <div className="col-4 divider-common-line right-line h-94vh overflow-y-auto">
                <div className='d-flex justify-content-between'>
                    <DividerWithText title={t('last_accesses')} withLine={false} />
                    <CustomTablePagination
                        rowsPerPage={guardSizes.userAccessLogSize}
                        onRowsPerPageChange={(e) => {
                            setSizeChanged(true);
                            setFirstLoad(true);
                            setGuardSizes((prevData) => ({
                                ...prevData,
                                userAccessLogSize: e.target.value,
                            }));
                            sessionStorage.setItem('guardAccessSize', e.target.value);
                        }}
                    />
                </div>
                <UserAccessLogs
                    list={guardLists.userAccessLogs}
                />
            </div>
            <div className="col-4 divider-common-line right-line h-94vh overflow-y-auto">
                <div className='d-flex justify-content-between'>
                    <DividerWithText title={t('incoming_invitations')} withLine={false} />
                    <CustomTablePagination
                        rowsPerPage={guardSizes.userInvitationSize}
                        onRowsPerPageChange={(e) => {
                            setSizeChanged(true);
                            setFirstLoad(true);
                            setGuardSizes((prevData) => ({
                                ...prevData,
                                userInvitationSize: e.target.value,
                            }));
                            sessionStorage.setItem('guardInvitationsSize', e.target.value);
                        }}
                    />
                </div>
                <UserInvitations
                    list={guardLists.userInvitations}
                    userDataTransformVisitor={userDataTransformVisitor}
                />
            </div>
            <div className="col-4 divider-common-line right-line h-94vh overflow-y-auto">
                <div className='d-flex justify-content-between'>
                    <DividerWithText title={t('incoming_events')} withLine={false} />
                    <CustomTablePagination
                        rowsPerPage={guardSizes.eventSize}
                        onRowsPerPageChange={(e) => {
                            setSizeChanged(true);
                            setFirstLoad(true);
                            setGuardSizes((prevData) => ({
                                ...prevData,
                                eventSize: e.target.value,
                            }));
                            sessionStorage.setItem('guardEventsSize', e.target.value);
                        }}
                    />
                </div>
                <IncomingEvents
                    list={guardLists.events}
                    userDataTransformHost={userDataTransformHost}
                    userDataTransformValidatedBy={userDataTransformValidatedBy}
                />
            </div>
            <div className="col-4 divider-common-line right-line h-94vh overflow-y-auto">
                <div className='d-flex justify-content-between'>
                    <DividerWithText title={t('active_contracts')} withLine={false} />
                    <CustomTablePagination
                        rowsPerPage={guardSizes.contractSize}
                        onRowsPerPageChange={(e) => {
                            setSizeChanged(true);
                            setFirstLoad(true);
                            setGuardSizes((prevData) => ({
                                ...prevData,
                                contractSize: e.target.value,
                            }));
                            sessionStorage.setItem('guardContractsSize', e.target.value);
                        }}
                    />
                </div>
                <ActiveContracts
                    list={guardLists.contracts}
                    userDataTransformContractor={userDataTransformContractor}
                />
            </div>
            <div className="col-4 divider-common-line right-line h-94vh overflow-y-auto">
                <div className='d-flex justify-content-between'>
                    <DividerWithText title={t('incoming_orders')} withLine={false} />
                    <CustomTablePagination
                        rowsPerPage={guardSizes.orderSize}
                        onRowsPerPageChange={(e) => {
                            setSizeChanged(true);
                            setFirstLoad(true);
                            setGuardSizes((prevData) => ({
                                ...prevData,
                                orderSize: e.target.value,
                            }));
                            sessionStorage.setItem('guardOrdersSize', e.target.value);
                        }}
                    />
                </div>
                <IncomingOrders
                    list={guardLists.orders}
                    userDataTransformSupplierEmployee={userDataTransformSupplierEmployee}
                    userDataTransformSupplierVehicle={userDataTransformSupplierVehicle}
                />
            </div>
        </div>
    );
};

export default Guard;
